document.addEventListener("DOMContentLoaded", () => {
  if (window.Alpine && !window.__ALPINE_STARTED__) {
	window.__ALPINE_STARTED__ = true;
	window.Alpine.start();
  }
});